import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import ActionButtons from '.././home/ActionButtons';

 class ShowOverlays extends Component {
  constructor(){
    super();
    autoBind(this);
  }
  renderOverlayRows(){
    const { overlays } = this.props
    return  overlays.results.map((overlay,i)=> 
        <TableRow key={i}>
          <TableRowColumn key={i}>{overlay.altTxt}</TableRowColumn>
          <TableRowColumn key={i}>{overlay.width}x{overlay.height}</TableRowColumn>
          <TableRowColumn key={i}>{overlay.category}</TableRowColumn>
          <TableRowColumn key={i}>
            <Checkbox defaultChecked={overlay.disabled} disabled/>
          </TableRowColumn>
          <TableRowColumn key={i}>
            <ActionButtons
              onEdit={`/overlays/edit/${overlay.id}`}
            />
          </TableRowColumn>
        </TableRow>
  )
}
render(){
   const tableStyles = {
    stripedRows: true,
    displaySelectAll: false,
    adjustForCheckbox: false,
    selectable: false,
    displayRowCheckbox: false,
  }
  return(
    <div>
      <div style={{margin: "20px"}} className="action-buttons">
        <Link to="/overlays/new">
          <RaisedButton
            label="Add New Overlay"
            primary
          />
        </Link>
      </div>
      <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Size</TableHeaderColumn>
              <TableHeaderColumn>Category</TableHeaderColumn>
              <TableHeaderColumn>Disabled</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderOverlayRows()}
          </TableBody>
        </Table> 
    </div>
  )
}
}

export default ShowOverlays 


// WEBPACK FOOTER //
// ./src/components/overlays/ShowOverlays.js